import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import formatDate from '../../utils/formatDate';
import paths from '../../paths';

export class NewsItem extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    alias: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    announce: PropTypes.string.isRequired,
  }

  render() {
    const {
      title, alias, date, announce,
    } = this.props;
    return (
      <article className="news__item">
        <div className="news__item-wrapper">
          <Link to={`${paths.advocates.news}/${alias}`} className="news__title">
            {title}
          </Link>
          <p className="news__description" dangerouslySetInnerHTML={{ __html: announce }} />
        </div>
        <time className="news__date">{formatDate(date, 'forNews')}</time>
      </article>
    );
  }
}
